export default {
      id: "check-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#check",
      toString: function () {
        return this.url;
      }
    }